export const FORM_WORKFLOW_PATH = "/apps/form-workflow";

export const FORMS_LIST_PATH = `${FORM_WORKFLOW_PATH}/forms`;
export const getFormViewPath = (id: string | number) =>
  `${FORMS_LIST_PATH}/view/${id}`;

export const FORM_BUILDER_PATH = `${FORMS_LIST_PATH}/builder`;
export const getFormBuilderPath = (id?: string | number) =>
  id ? `${FORM_BUILDER_PATH}/${id}` : FORM_BUILDER_PATH;
